import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class ComponentMessagingService {

    private subject = new Subject<any>();

    sendMessage(message: string, payload?: any) {
        this.subject.next({ text: message, payload });
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    clearMessages() {
        this.subject.complete();
        this.subject = new Subject<any>();
    }
}
